import React, { useEffect, useMemo, useRef, useState } from 'react'
import Styles from './webcamera.module.scss'
import { DotLoading, Mask, Tag, Toast } from 'antd-mobile'
import Header from '../../common/Header';
import useCameraService from './useCameraService';
import { useUpdateEffect } from 'ahooks';
import { CheckCircleOutline, CloseCircleOutline } from 'antd-mobile-icons';
import { userStore } from '../../../store';

export default function WebCamera() {

    const webcameraRef = useRef();
    const canvas = useRef();

    const [visible, setVisible] = useState(false);
    const { faceResult, setFaceResult, faceCompare } = useCameraService();

    const {userId} = userStore;

    useEffect(() => {
        // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
        if (navigator.mediaDevices === undefined) {
            navigator.mediaDevices = {};
        }

        // 一些浏览器部分支持 mediaDevices。我们不能直接给对象设置 getUserMedia
        // 因为这样可能会覆盖已有的属性。这里我们只会在没有getUserMedia属性的时候添加它。
        if (navigator.mediaDevices.getUserMedia === undefined) {
            navigator.mediaDevices.getUserMedia = function (constraints) {

                // 首先，如果有getUserMedia的话，就获得它
                var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

                // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
                if (!getUserMedia) {
                    return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
                }

                // 否则，为老的navigator.getUserMedia方法包裹一个Promise
                return new Promise(function (resolve, reject) {
                    getUserMedia.call(navigator, constraints, resolve, reject);
                });
            }
        }

        navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
            var video = webcameraRef.current;
            // 旧的浏览器可能没有srcObject
            if ("srcObject" in video) {
                video.srcObject = stream;
            } else {
                // 防止在新的浏览器里使用它，应为它已经不再支持了
                video.src = window.URL.createObjectURL(stream);
            }
            video.onloadedmetadata = function (e) {
                video.play();
            };
        }).catch(function (err) {
            Toast.show({
                content: err.name + ": " + err.message
            })
        });
        return () => {

        }
    }, [])


    /**
    * 获取video中对应的真实size
    */
    function getXYRatio() {
        // videoHeight为video 真实高度
        // offsetHeight为video css高度
        const { videoHeight: vh, videoWidth: vw, } = webcameraRef.current;

        return {
            vh,
            vw
        };
    }

    const feedBackStaus = useMemo(() => {
        return faceResult != null ?
            (faceResult ?
                <>
                    <CheckCircleOutline fontSize={30} color='#76c6b8' />
                    <div style={{ height: 5 }} />
                    <span>验证成功,3秒后返回</span>
                </>
                :
                <>
                    <CloseCircleOutline fontSize={36} color='var(--adm-color-danger)' />
                    <div style={{ height: 5 }} />
                    <span>失败,请调整下位置再验证</span>
                </>
            )
            :
            <>
                <DotLoading />
                <span className={`${Styles.tips}`}>正在验证人脸中</span>
            </>
    }, [faceResult])

    useUpdateEffect(() => {
        if (faceResult === true) {
            localStorage.setItem(`${userId}_faceValidate`,'done')
            setTimeout(() => {
                setVisible(false)
                setFaceResult(null)
                webcameraRef.current.play()
                window.history.back()
            }, 3000);
        }
        if (faceResult === false) {
            setTimeout(() => {
                setVisible(false)
                setFaceResult(null)
                webcameraRef.current.play()
            }, 3000);
        }
    }, [faceResult])


    const takePhoto = () => {
        webcameraRef.current.pause()
        localStorage.setItem(`${userId}_faceValidate`,'done')
            setTimeout(() => {
                setVisible(false)
                setFaceResult(null)
                webcameraRef.current.play()
                window.history.back()
        }, 1000)
        /*
        const { vw, vh } = getXYRatio();
        canvas.current.width = vw;
        canvas.current.height = vh;
        canvas.current.getContext('2d').drawImage(webcameraRef.current, 0, 0, vw, vh);
        const fileStr = canvas.current.toDataURL("image/png"); // 将图片资源转成字符串
        setVisible(true)
        faceCompare({ fileStr })
        */
    }

    const trigger = () => {
        // console.log(webcameraRef.current.play())
    }

    return (
        <div className={Styles.camera}>
            {/* <Header className={`${Styles.back} flex-col`}>
                <div className={`${Styles.arrow} flex-col`} />
            </Header> */}
            <video
                ref={webcameraRef}
                className={`${Styles.video}`}
                autoPlay
                muted
                playsInline
                style={{
                    width: '80%',
                    height: '60%',
                    objectFit: 'fill'
                }}
            />
            <div className={`${Styles.btns}`}>
                <button className={`${Styles.btn}`} onClick={takePhoto}>人脸验证</button>
            </div>
            <div className={`${Styles.manual}`}>
                <span style={{zIndex:3}}>未自动加载人脸视频 ？</span>  <Tag round color='#b5b2b1' style={{ marginLeft: 10,zIndex:3,padding: '3px 10px' }} fill='outline' onClick={trigger}>手动加载</Tag>
            </div>
            <div className={`${Styles.toast} flex-col`} style={{zIndex:3,marginTop:10}}>注: 请确保头像尽量放置中间位置</div>
            <canvas ref={canvas} id="canvas" className={`${Styles.canvas}`}></canvas>
            <Mask
                visible={visible}
                onMaskClick={() => setVisible(false)}
                opacity='thick'
            >
                <div className={`${Styles.overlayContent}`}>
                    {feedBackStaus}
                </div>
            </Mask>
        </div>
    )
}
